import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, useIsAuthenticated } from '@/shared/auth/store';
import { bootstrapAuth, isAuthBootstrapDone } from '@/shared/auth/bootstrap';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const isAuth = useIsAuthenticated();
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  // 새로고침 직후: user 는 persist 되어 있지만 accessToken 은 메모리에 없다.
  // refresh 쿠키로 복원을 시도하는 동안 로그인 리다이렉트를 보류한다.
  const [booting, setBooting] = useState(!isAuth && !!user && !isAuthBootstrapDone());

  useEffect(() => {
    if (!booting) return;
    let mounted = true;
    bootstrapAuth().finally(() => {
      if (mounted) setBooting(false);
    });
    return () => {
      mounted = false;
    };
  }, [booting]);

  if (booting) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center" role="status">
        <span className="sr-only">로그인 상태 확인 중</span>
        <span
          aria-hidden="true"
          className="h-2.5 w-2.5 animate-ping rounded-full bg-primary"
        />
      </div>
    );
  }
  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
